(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CIVIL-13-DAYS-OF-FRIGHT"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('civil-fright-campaign')) {
  customElements.define('civil-fright-campaign', class extends HTMLElement {
    connectedCallback() {
      this.onReady = () => this.initialize();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      } else {
        this.initialize();
      }
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.onReady);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
      clearInterval(this.interval);
      this.initialized = false;
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.items = [...this.querySelectorAll('[data-door]')].map(node => ({
        node,
        target: this.parseTime(node.dataset.unlock),
        force: node.dataset.state,
        counter: node.querySelector('[data-countdown]'),
        units: ['days', 'hours', 'minutes', 'seconds'].map(unit => node.querySelector('[data-' + unit + ']')),
        invalid: node.querySelector('[data-invalid]'),
        nextLabel: node.querySelector('[data-next-label]'),
        link: node.querySelector('[data-open-link]')
      }));
      this.onClick = event => {
        const link = event.target.closest('[data-open-link]');
        if (link) {
          this.update();
          if (link.getAttribute('aria-disabled') === 'true' || !link.hasAttribute('href')) {
            event.preventDefault();
          }
        }
      };
      this.addEventListener('click', this.onClick);
      this.onVisibility = () => {
        clearInterval(this.interval);
        this.update();
        if (!document.hidden) this.interval = setInterval(() => this.update(), 1000);
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.onVisibility();
      const copy = this.querySelector('.fc-hero-copy');
      this.observer = new ResizeObserver(() => this.fitTitle());
      if (copy) this.observer.observe(copy);
      this.fitTitle();
      document.fonts?.ready.then(() => { if (this.isConnected) this.fitTitle(); });
    }
    parseTime(value) {
      if (!value) return NaN;
      const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/);
      if (!match) return NaN;
      const [, year, month, day, hour, minute, second = '0', offset] = match;
      const monthNumber = Number(month);
      const dayNumber = Number(day);
      const daysInMonth = new Date(Date.UTC(Number(year), monthNumber, 0)).getUTCDate();
      if (monthNumber < 1 || monthNumber > 12 || dayNumber < 1 || dayNumber > daysInMonth || Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59) return NaN;
      if (offset !== 'Z' && (Number(offset.slice(1, 3)) > 23 || Number(offset.slice(4)) > 59)) return NaN;
      return Date.parse(value.trim());
    }
    fitTitle() {
      const title = this.querySelector('.fc-title');
      if (!title) return;
      const width = title.clientWidth;
      const scale = Number.parseFloat(getComputedStyle(this).getPropertyValue('--fc-title-scale')) || 1;
      this.querySelectorAll('[data-title-line]').forEach(line => {
        line.style.fontSize = '100px';
        const measured = line.getBoundingClientRect().width;
        if (measured > 0) line.style.fontSize = Math.max(12, width / measured * 100 * scale) + 'px';
      });
    }
    update() {
      const editor = this.dataset.designMode === 'true';
      const preview = editor ? this.dataset.preview : 'live';
      const previewDate = preview === 'date' ? this.parseTime(this.dataset.previewTime) : NaN;
      const now = Number.isFinite(previewDate) ? previewDate : Date.now();
      let next = null;
      this.items.forEach(item => {
        const forcedOpen = preview === 'open' || (preview !== 'locked' && item.force === 'open');
        const forcedLocked = preview === 'locked' || (preview !== 'open' && item.force === 'locked');
        const valid = Number.isFinite(item.target);
        const open = forcedOpen || (!forcedLocked && valid && now >= item.target);
        item.node.classList.toggle('is-open', open);
        item.node.classList.toggle('is-locked', !open);
        item.node.classList.remove('is-next');
        item.nextLabel.hidden = true;
        if (item.link) {
          if (open) {
            item.link.setAttribute('href', item.link.dataset.href);
            item.link.removeAttribute('aria-disabled');
            item.link.removeAttribute('tabindex');
          } else {
            item.link.removeAttribute('href');
            item.link.setAttribute('aria-disabled', 'true');
            item.link.setAttribute('tabindex', '-1');
          }
        }
        if (open) return;
        const waitingForTime = valid && item.target > now;
        item.counter.hidden = !waitingForTime;
        item.invalid.hidden = waitingForTime;
        if (waitingForTime) {
          const seconds = Math.max(0, Math.ceil((item.target - now) / 1000));
          const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
          values.forEach((value, index) => {
            const text = String(value).padStart(2, '0');
            if (item.units[index].textContent !== text) item.units[index].textContent = text;
          });
          if (!forcedLocked && (!next || item.target < next.target)) next = item;
        }
      });
      if (next) {
        next.node.classList.add('is-next');
        next.nextLabel.hidden = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
